import { isAppStore } from "@/lib/globals"

export default () =>
  isAppStore() === true || window.location.host.indexOf(".app-store") !== -1
